import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components';
import { useDocumentTitle } from '@/common/hooks/useDocumentTitle';

const RETURN_PATH_KEY = 'aexon-return-path';

function safeReturnPath(authed) {
  if (!authed) return '/login';
  try {
    const saved = sessionStorage.getItem(RETURN_PATH_KEY);
    if (saved && !saved.startsWith('/not-found')) return saved;
  } catch {
    /* ignore */
  }
  return '/dashboard';
}

export function NotFound({ variant = 'page' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const card = variant === 'card' || location.state?.unavailable === 'card';
  const authed = Boolean(localStorage.getItem('access_token'));

  useDocumentTitle(
    card ? 'Business card unavailable | Aexon' : 'Page Not Found | Aexon',
  );

  const goBack = () => {
    navigate(safeReturnPath(authed));
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 py-8">
      <div className="bg-gray-500/10 p-4 rounded-full mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-gray-500"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-black mb-2">
        {card ? 'Unavailable' : 'Page Not Found'}
      </h2>
      <p className="text-zinc-500 mb-8 max-w-md">
        {card
          ? 'This business card is unavailable.'
          : 'The page you’re looking for doesn’t exist or is no longer available.'}
      </p>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 w-full max-w-md">
        {authed ? (
          <>
            <Button
              type="button"
              variant="secondary"
              onClick={goBack}
              className="w-full sm:w-auto"
            >
              Go Back
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={() => navigate('/dashboard')}
              className="w-full sm:w-auto"
            >
              Go to Dashboard
            </Button>
          </>
        ) : (
          <Button
            type="button"
            variant="primary"
            onClick={() => navigate('/login')}
            className="w-full sm:w-auto"
          >
            Sign In
          </Button>
        )}
      </div>
    </div>
  );
}
